import { agent_model } from '@/views/agent/models/agent_model';
import concepto_model from '@/shared/models/concepto_model';
import deposito_model from '@/shared/models/deposito_model';
import talonario_model from '@/shared/models/talonario_model';

export const inventory_movement_model = {
  Anulado: false,
  Codigo: null,
  CodigoConcepto: null,
  CodigoDeposito: null,
  CodigoDepositoDestino: null,
  CodigoEntidad: null,
  CodigoTalonarioExterno: null,
  CodigoTalonarioInterno: '',
  Concepto: { ...concepto_model },
  Deposito: { ...deposito_model },
  DepositoDestino: { ...deposito_model },
  Detalles: [],
  Eliminado: false,
  Entidad: { ...agent_model },
  Estado: null,
  FechaExterna: null,
  FechaInterna: '',
  LugarEntrega: null,
  Movimiento: null,
  NumeroExterno: null,
  NumeroInterno: null,
  Observaciones: null,
  PrefijoExterno: null,
  PrefijoInterno: null,
  TalonarioExterno: { ...talonario_model },
  TalonarioExternoTexto: '',
  TalonarioInterno: { ...talonario_model },
  TipoComprobante: null,
  TipoEntidad: null,
  UsuarioAnulacion: null,
  UsuarioEliminacion: null,
  UsuarioCreacion: null,
};

export const inventory_movement_filters = {};
